import { useAuth } from '../../auth/AuthProvider';
import { addAccessTokenToUrl } from '../global/addAccessTokenToUrl';

/**
 * Hook to get attachment URL with access_token query parameter
 * Use this in React components that need to display or download attachments
 */
export function useAttachmentUrl(url: string): string {
  const { accessToken } = useAuth();
  return addAccessTokenToUrl(url, accessToken || undefined);
}
